import { useEffect, useState } from "react";

/**
 * Hook to fix a bug with React Hydration when using
 * typeof window !== undefined
 *
 * More info here:
 *
 * @link https://nextjs.org/docs/messages/react-hydration-error
 **/
const useIsClient = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
};

export default useIsClient;
